import type { Club } from "@/lib/api";
import { sectionById } from "@/lib/sections";
import { useReveal } from "@/lib/useReveal";
import { SectionHeader } from "./SectionHeader";

interface ClubSectionProps {
  readonly club: Club | null;
}

const PILLARS = [
  {
    piece: "j" as const,
    title: "All skill levels",
    body: "Whether you are learning the basics or are a top player, on NES or modern guideline, you are welcome. Come to a meeting, find a screen, and play.",
  },
  {
    piece: "l" as const,
    title: "Improve your play",
    body: "Puzzles, opener theory and downstack practice, alongside members who will review your replays and help you work out what to change.",
  },
  {
    piece: "s" as const,
    title: "Compete for UCI",
    body: "We field a team in the Collegiate Tetris League. Places are open to any member who wants to play competitively.",
  },
];

export function ClubSection({ club }: ClubSectionProps) {
  const ref = useReveal<HTMLDivElement>();
  const section = sectionById("club")!;

  return (
    <section id="club" className="shell py-16 sm:py-20 md:py-24">
      <SectionHeader section={section} kicker="What membership involves" />

      <div ref={ref} className="reveal" data-shown="false">
        <p className="max-w-[54ch] text-xl leading-snug font-medium sm:text-2xl">
          {club?.blurb}
        </p>

        <div className="mt-10 grid gap-5 sm:gap-6 md:grid-cols-3">
          {PILLARS.map((pillar) => (
            <article key={pillar.title} className="panel offset-ink-sm flex flex-col p-6">
              <span
                className="mb-5 block h-2.5 w-16"
                style={{ background: `var(--color-piece-${pillar.piece})` }}
              />
              <h3 className="text-2xl">{pillar.title}</h3>
              <p className="mt-3 text-[0.9375rem] leading-relaxed opacity-80">{pillar.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
